// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import closeQuickViewModal from "@bg/App/Handlers/ProductQuickView/CloseQuickViewModal";
import { CustomAppState } from "@bg/App/Store/Reducers";
import { getQuickViewProductState, getSelectedImage } from "@bg/App/Store/Selectors/ProductQuickView/QuickViewSelector";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import React from "react";
import { connect, ResolveThunks } from "react-redux";

type OwnProps = {
    children?: any;
};

const mapDispatchToProps = {
    closeQuickViewModal,
};

const mapStateToProps = (state: CustomAppState) => {
    const { isModalOpen } = getQuickViewProductState(state);
    return {
        isQuickViewModalOpen: isModalOpen,
    };
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const RedirectToSignIn = ({ children, closeQuickViewModal, isQuickViewModalOpen }: Props) => {
    const doSignIn = () => {
        if (isQuickViewModalOpen) {
            closeQuickViewModal();
        }
        const headerSignIn = document.getElementsByClassName("header_signIn");
        if (headerSignIn && headerSignIn.length) {
            (headerSignIn[0] as any).click();
        }
    };

    return <Clickable onClick={doSignIn}>{children}</Clickable>;
};

export default connect(mapStateToProps, mapDispatchToProps)(RedirectToSignIn);
